import ICharacter from "../Models/ICharacter";

const characters: { [id: string]: ICharacter } = {

    "sarnas": {
        "name": "Sarnas",
        "scientific_name": "Aglais Io",
        "species": "paon-du-jour",
        "archetype": "barde",
        "color": "#B3CBE6",
        "background": "#b5c2e5",
        "description": "Il m'arrive parfois de m'éblouir moi-même tant que mon talent et mon apparence sont éclatants."
    },
    "grizel": {
        "name": "Grizel",
        "scientific_name": "Lucilia caesar",
        "species": "mouche",
        "archetype": "sorcier",
        "color": "#CEB8CE",
        "background": "#e9b4d1",
        "description": "J'ai peut-être l'air fragile mais je suis aussi dangeureuse avec mes enchantements que n'importe quel combattant au corps à corps."
    },
    "jagos": {
        "name": "Jagos",
        "scientific_name": "Bombus terrestris",
        "species": "bourdon",
        "archetype": "druide",
        "color": "#B2DAD7",
        "background": "#abc3b9",
        "description": "C'est important pour moi de prendre soin de tous les êtres vivants car chacun a sa place spéciale dans l'univers."
    },
    "emette": {
        "name": "Emette",
        "scientific_name": "Coccinnella septempunctata",
        "species": "coccinelle",
        "archetype": "roublard",
        "color": "#F3CFAA",
        "background": "#f8b780",
        "description": "Je concidère qu'il peut y avoir plusieurs vérités : celle que les autres voient et surtout celle qui m'arrange."
    },
    "drakha": {
        "name": "Drakha",
        "scientific_name": "Pemphredon inornata",
        "species": "guepe",
        "archetype": "chasseur",
        "color": "#E3D8C5",
        "background": "#b4a58e",
        "description": "Quand j'ai décidé de traquer une proie, rien ne peut me faire dévier de mon objectif !"
    },
    "etor": {
        "name": "Etor",
        "scientific_name": "Cetonia aurata",
        "species": "scarabee",
        "archetype": "guerrier",
        "color": "#C8E2C6",
        "background": "#b9c7a0",
        "description": "C'est un honneur de servir mon peuple pour lequel je n'hésiterais pas à risquer ma vie."
    },
}

export default characters;